<script lang="ts">
import type { CompositePrimaryKey } from '#layers/data-model/public';

export interface ListingSelectionActionsProps {
	selection: CompositePrimaryKey[];
	visible?: boolean;
	canBulkDelete?: boolean;
	deleteLabel?: string;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import { ButtonRemove } from '#layers/ui/public';

const {
	// eslint-disable-next-line unicorn/no-useless-undefined -- without a default, Vue casts an absent Boolean prop to false
	visible = undefined,
	selection,
} = defineProps<ListingSelectionActionsProps>();

defineEmits<{
	clear: [];
	deleteItems: [];
}>();

const appConfig = useAppConfig();

const isVisible = computed(() => (visible ?? true) && selection.length > 0);
</script>

<template>
	<DHeaderOverlay :open="isVisible">
		<div class="flex flex-1 items-center justify-between px-page">
			<div class="flex items-center gap-2">
				<DTooltip :text="$t('listing.selection.clear')">
					<DButton class="-ms-1.5" color="neutral" variant="ghost" size="sm" :icon="appConfig.ui.icons.close" @click="$emit('clear')" />
				</DTooltip>
				<span class="text-sm font-medium tabular-nums">
					{{ $t('common.selection_count', { n: selection.length }) }}
				</span>
			</div>
			<div class="flex items-center gap-2">
				<ButtonRemove
					v-if="canBulkDelete"
					variant="outline"
					with-leading-icon
					:label="deleteLabel ?? $t('common.delete')"
					@click="$emit('deleteItems')"
				/>
			</div>
		</div>
	</DHeaderOverlay>
</template>
